import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface LogoMarkProps {
    className?: string
}

interface LogoProps {
    className?: string
    showMark?: boolean
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.3'
            strokeLinecap='round'
            aria-hidden='true'
            className={cn('size-7', className)}
        >
            <path d='M10.5 9h11' />
            <path d='M16 9v15' />
            <path d='M12.5 24h7' />
            <path d='M7.5 12.5c0 6.2 3.6 10.6 8.5 11.5' />
            <path d='M24.5 12.5c0 6.2-3.6 10.6-8.5 11.5' />
            <path d='M8.6 16.2l-2 -0.9M9.8 19.6l-2 -0.4M11.8 22.2l-1.6 0.4' />
            <path d='M23.4 16.2l2 -0.9M22.2 19.6l2 -0.4M20.2 22.2l1.6 0.4' />
        </svg>
    )
}

const Logo: FC<LogoProps> = ({ className, showMark = true }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-3 text-brass', className)}>
            {showMark && <LogoMark />}

            <span className='font-heading text-[1.6rem] leading-none font-semibold tracking-[0.3em] mr-[-0.3em]'>
                TROFÉA
            </span>
        </span>
    )
}

export default Logo
